module.exports = __webpack_public_path__ + "img/0.955cc5c1.jpg";